export const lengthUnicode = (string: string): number => {
	let len = 0;
	for (const _ch of string) {
		len++;
	}
	return len;
};

export const substringUnicode = (string: string, maxLength: number): string => {
	let len = 0;
	let result = '';
	for (const ch of string) {
		if (len++ >= maxLength) {
			break;
		}
		result += ch;
	}
	return result;
};

export const clampString = (string: string, maxLength: number): string => {
	if (lengthUnicode(string) > maxLength) {
		return `${substringUnicode(string, maxLength - 3)}...`;
	}
	return string;
};
